export const validationPatterns = {
	email: '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
	phone: '^(?:549?)?(?:11|[2368]\\d)(?:([2-9]\\\\d{2}/(?:!11))\\d{2})??\\d{8}$',
	password: '^(?=.{5,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).*$',
	cuit: '^(?=.{11,}$)(?=.*?[0-9]).*$'
};
